// extracted by mini-css-extract-plugin
module.exports = {"container":"container___4xe1j","href":"href___3SRA9","date":"date___2Y1U2","authors":"authors___2Ba5o"};